.wrapper {
  border-radius: 2px;
  font-size: 15px;
  font-weight: 600;
  line-height: 20px;
  transition: none;

  &:global(.ant-btn-default) {
    border-color: var(--x-color-border);
  }

  &:global(.ant-btn-primary) {
    border-color: transparent;
    color: var(--x-color-text-white);
  }

  &:global(.ant-btn-link) {
    height: inherit;
    border-color: transparent;
  }

  &:global(.ant-btn-lg) {
    height: auto;
    min-height: 40px;
    white-space: break-spaces;
  }

  a&:global(.ant-btn-lg) {
    line-height: 25px;
  }

  &:global(.ant-btn-primary)[disabled] {
    border: 1px solid var(--x-color-border);
    color: var(--x-color-text-secondary-disabled);
  }

  &:not([disabled]):hover,
  &:not([disabled]):focus {
    animation: 0s;
    color: var(--x-color-text-accent-active);
  }

  &:global(.ant-btn-default):not([disabled]):hover,
  &:global(.ant-btn-default):not([disabled]):focus {
    border-color: var(--x-color-border);
  }

  &:global(.ant-btn-primary):not([disabled]):hover,
  &:global(.ant-btn-primary):not([disabled]):focus {
    background-color: var(--x-color-text-accent-active);
    color: var(--x-color-text-white);

    svg path {
      fill: var(--x-color-text-white);
    }
  }

  &:global(.ant-btn-primary):global(.ant-btn-dangerous):not([disabled]) {
    background: var(--x-color-action-orange);
  }

  &:global(.ant-btn-default):global(.ant-btn-dangerous):not([disabled]):hover,
  &:global(.ant-btn-default):global(.ant-btn-dangerous):not([disabled]):focus {
    border-color: transparent;
    background: white;
    color: var(--x-color-text-orange-active);
  }

  &:global(.ant-btn-primary):global(.ant-btn-dangerous):not([disabled]):hover,
  &:global(.ant-btn-primary):global(.ant-btn-dangerous):not([disabled]):focus {
    border-color: transparent;
    background: var(--x-color-text-orange-active);
  }
}

.noPadding {
  padding: 0;
}
